/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface Address
 */
export interface Address {
  /**
   * city, town
   * @type {string | null}
   * @memberof Address
   */
  city?: string | null;
  /**
   * 2-letter country code
   * @type {string | null}
   * @memberof Address
   */
  country?: string | null;
  /**
   * street address
   * @type {string | null}
   * @memberof Address
   */
  line1?: string | null;
  /**
   * apt, suite, etc
   * @type {string | null}
   * @memberof Address
   */
  line2?: string | null;
  /**
   * address name
   * @type {string | null}
   * @memberof Address
   */
  name?: string | null;
  /**
   * zip code, postal code
   * @type {string | null}
   * @memberof Address
   */
  postalCode?: string | null;
  /**
   * state, province, region
   * @type {string | null}
   * @memberof Address
   */
  region?: string | null;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): value is Address {
  return true;
}

export function AddressFromJSON(json: any): Address {
  return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Address {
  if (json == null) {
    return json;
  }
  return {
    city: json['city'] == null ? undefined : json['city'],
    country: json['country'] == null ? undefined : json['country'],
    line1: json['line1'] == null ? undefined : json['line1'],
    line2: json['line2'] == null ? undefined : json['line2'],
    name: json['name'] == null ? undefined : json['name'],
    postalCode: json['postal_code'] == null ? undefined : json['postal_code'],
    region: json['region'] == null ? undefined : json['region'],
  };
}

export function AddressToJSON(value?: Address | null): any {
  if (value == null) {
    return value;
  }
  return {
    city: value['city'],
    country: value['country'],
    line1: value['line1'],
    line2: value['line2'],
    name: value['name'],
    postal_code: value['postalCode'],
    region: value['region'],
  };
}
